// extracted by mini-css-extract-plugin
export default {"container":"BAeY6n7tnl63hbuCrbfy","card":"AOtQCUHqfU1zvd9jFD0W","title":"Ofe7KDYOs3bkOjFvk8AC"};